import axios from 'axios';
import { CommonResult, createApiRequestUrl, OK } from '../Common';
import { API_EXCEPTION_MSG } from '../../Common';

const URL = createApiRequestUrl('master/messageList');

export interface MessageListApiRequest {
  level: number;
  display_flg: boolean;
  api_flg: boolean;
  batch_flg: boolean;
}

export interface MessageInfo {
  messageId: string;
  message: string;
  level: number;
  levelName: string;
}

export interface MessageListApiResponse {
  messageList: Array<MessageInfo>;
  result: CommonResult;
}

export interface MessageListApiErrorResponse {
  messageList: Array<MessageInfo>;
  result: CommonResult;
}

export async function messageListApiPost(request: MessageListApiRequest): Promise<MessageListApiResponse> {
  try {
    const headers = {
      'Content-Type': 'application/json',
    };
    const response = await axios.post<MessageListApiResponse>(URL, request, { headers });
    const data = response.data;
    const status = response.status;

    switch (status) {
      case OK.status:
        return data;
      default:
        throw response;
    }
  } catch (error) {
    // TODO: エラーハンドリング実装後
    return {
      messageList: [],
      result: {
        jobDateTime: '',
        resultCd: '9999',
        resultMessageDtoList: [
          {
            resultMessageCd: '9999',
            resultMessage: `${API_EXCEPTION_MSG}  エラー内容:[${error}]`,
          },
        ],
      },
    };
  }
}
